import React, { useState } from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import { Box } from '@mui/system'
import { Button } from '@mui/material'
import { ChevronRightRounded, SmartDisplayRounded } from '@mui/icons-material'
import { QuestionState } from '../../../../features/types'
import VideoExplanationDialog from './VideoExplanationDialog'
import ResultOption from './ResultOption'

interface Props {
    index: number
    question: QuestionState
}

const ResultQuestion: React.FC<Props> = ({ question = null, index }) => {
    const { formatMessage } = useIntl()
    const [openDialog, setOpenDialog] = useState(false)

    const handleClose = () => {
        setOpenDialog(false)
    }
    const isCorrect = _.some(
        question.answers,
        (answer) => answer.correct && answer.correct === answer.isChecked,
    )

    // const message = () => {
    //     if (isCorrect) {
    //         return 'Замечательно!'
    //     }

    //     return 'Не волнуйтесь, вы все ещё учитесь!'
    // }

    const styles = {
        content: {
            display: 'flex',
            mb: 2,
        },
        wrapper: {
            border: '1px solid #EDEFF4',
            borderRadius: '8px',
            p: 3,
            mb: 3,
        },
        message: {
            mb: 2,
            fontWeight: 600,
            fontSize: '15px',
            color: isCorrect ? '#00B998' : '#EA4F74',
        },
        buttonBox: {
            display: 'flex',
            mt: 2,
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.content}>
                {index + 1}.{' '}
                <Box dangerouslySetInnerHTML={{ __html: question.content }} />
            </Box>

            {/* <Box mb={2}>Выберите правильный термин</Box> */}

            {/* <Box sx={styles.message}>{message()}</Box> */}

            <Box>
                {question.answers.map((answer, index) => (
                    <ResultOption
                        key={answer.id}
                        index={index}
                        answer={answer}
                        selected={answer.isChecked}
                    />
                ))}
            </Box>

            <Box sx={styles.buttonBox}>
                <Button
                    variant="outlined"
                    startIcon={<SmartDisplayRounded />}
                    endIcon={<ChevronRightRounded />}
                    sx={{ marginLeft: 'auto' }}
                    onClick={() => setOpenDialog(true)}
                >
                    {formatMessage({ id: 'watchVideoSolution' })}
                </Button>
            </Box>

            <VideoExplanationDialog
                question={question}
                open={openDialog}
                handleClose={handleClose}
                confirmAction={handleClose}
            />
        </Box>
    )
}

export default ResultQuestion
